<template>
  <AppLayout :breadcrumbs="[{ label: 'Dashboard', link: '/dashboard' }]">
    <div class="layout-header">
      <div class="header-left">
        <ViewSelector v-model="selectedReport" :view-types="reportTypes" />
        <!-- Teleport target for report-specific controls -->
        <div id="report-controls"></div>
      </div>
      <div class="header-right">
        <button class="button" @click="handlePrint">Print</button>
      </div>
    </div>

    <div class="layout-body">
      <component :is="currentReportComponent" :key="selectedReport" ref="currentReport" />
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from '@/components/app/AppLayout.vue';
import ViewSelector from '@/components/common/ViewSelector.vue';
import FinancialsReport from '@/components/custom/FinancialsReport.vue';
import CounselorsReport from '@/components/custom/CounselorsReport.vue';
import CounselorDetailsReport from '@/components/custom/CounselorDetailsReport.vue';
import ProductsReport from '@/components/custom/ProductsReport.vue';
import ProductDetailsReport from '@/components/custom/ProductDetailsReport.vue';
import DailyReport from '@/components/custom/DailyReport.vue';

export default {
  name: 'DashboardView',
  components: {
    AppLayout,
    ViewSelector,
    FinancialsReport,
    CounselorsReport,
    CounselorDetailsReport,
    ProductsReport,
    ProductDetailsReport,
    DailyReport
  },
  data() {
    return {
      selectedReport: 'daily',
      reportTypes: [
        { id: 'daily', label: 'Daily Sales Sheet' },
        { id: 'financials', label: 'Financials' },
        { id: 'counselors', label: 'Counselors' },
        { id: 'counselor-details', label: 'Counselor Details' },
        { id: 'products', label: 'Products' },
        { id: 'product-details', label: 'Product Details' }
      ]
    };
  },
  watch: {
    selectedReport() {
      this.syncStateToUrl();
    },
    '$route.query': {
      handler(newQuery, oldQuery) {
        if (JSON.stringify(newQuery) === JSON.stringify(oldQuery)) return;

        const urlReport = newQuery.report || 'daily';
        if (urlReport !== this.selectedReport) {
          this.selectedReport = urlReport;
        }
      }
    }
  },
  mounted() {
    // Load from URL if present
    if (this.$route.query.report) {
      this.selectedReport = this.$route.query.report;
    } else {
      // Otherwise sync default to URL
      this.syncStateToUrl();
    }
  },
  computed: {
    currentReportComponent() {
      const reportMap = {
        'daily': 'DailyReport',
        'financials': 'FinancialsReport',
        'counselors': 'CounselorsReport',
        'counselor-details': 'CounselorDetailsReport',
        'products': 'ProductsReport',
        'product-details': 'ProductDetailsReport'
      };
      return reportMap[this.selectedReport] || 'DailyReport';
    },
    currentReportLabel() {
      const report = this.reportTypes.find(r => r.id === this.selectedReport);
      return report ? report.label : 'Report';
    }
  },
  methods: {
    syncStateToUrl() {
      const query = { ...this.$route.query };

      if (this.selectedReport && this.selectedReport !== 'daily') {
        query.report = this.selectedReport;
      } else {
        delete query.report;
      }

      this.$router.replace({ query }).catch(() => {});
    },
    handlePrint() {
      if (this.$refs.currentReport && typeof this.$refs.currentReport.generatePDF === 'function') {
        this.$refs.currentReport.generatePDF();
      }
    }
  }
}
</script>

<style scoped>
.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

#report-controls {
  display: flex;
  align-items: center;
}
</style>

